import { Injectable } from '@angular/core';

export interface PhaseEnvelopeCandidate {
  fluid: any;
  fluidEnvelope: any;
  operations?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class OperationEnvelopeOrchestrationService {
  private static readonly ZERO_GUID_PREFIX = '00000000';

  public getPreviousFluidId(operation: any, operations: any[]): string | null {
    let currentPrevId = operation.previousOperationId;

    while (currentPrevId && !currentPrevId.startsWith(OperationEnvelopeOrchestrationService.ZERO_GUID_PREFIX)) {
      const prevOp = operations.find((op: any) => op.id === currentPrevId || op.operationId === currentPrevId);
      if (!prevOp) {
        break;
      }

      const fluid = prevOp.inside?.fluid;
      if (fluid?.id) {
        return fluid.id;
      }

      currentPrevId = prevOp.previousOperationId;
    }

    return null;
  }

  public getPreviousOperationIdWithFluid(operation: any, operations: any[]): string | null {
    let currentPrevId = operation.previousOperationId;

    while (currentPrevId && !currentPrevId.startsWith(OperationEnvelopeOrchestrationService.ZERO_GUID_PREFIX)) {
      const prevOp = operations.find((op: any) => op.id === currentPrevId || op.operationId === currentPrevId);
      if (!prevOp) {
        break;
      }

      if (prevOp.inside?.fluid) {
        return prevOp.id;
      }

      currentPrevId = prevOp.previousOperationId;
    }

    return null;
  }

  public buildPhaseEnvelopesForMultipleData(
    fluids: any[],
    currentPhaseEnvelopes: PhaseEnvelopeCandidate[],
    operations: any[],
    defaultEnvelope: any
  ): PhaseEnvelopeCandidate[] {
    const fluidsNotInEnvelope = fluids
      .filter(x => !currentPhaseEnvelopes.some(y => y.fluid.id === x.id))
      .map(x => ({
        fluid: x,
        fluidEnvelope: defaultEnvelope,
      }));

    const basePhaseEnvelopes = [...currentPhaseEnvelopes, ...fluidsNotInEnvelope];
    const shutInOperations = operations.filter((x: any) => x.inside?.type === 'shutIn');

    return basePhaseEnvelopes.map((phaseEnvelope: any) => {
      const baseOperations = operations.filter((op: any) => op.inside?.['fluid']?.id === phaseEnvelope.fluid.id && op.inside?.['flow']?.co2EosOption === 'GERG2008');
      const derivedShutInOperations = shutInOperations
        .filter((s: any) => baseOperations.some((op: any) => op.id === s.previousOperationId))
        .map((s: any) => ({
          ...s,
          inside: baseOperations.find((op: any) => op.id === s.previousOperationId)?.inside ?? s.inside,
        }));

      const currentName = phaseEnvelope.fluid.state.name;
      const phaseEnvelopeName = currentName.endsWith(' - Phase Envelope') ? currentName : `${currentName} - Phase Envelope`;

      return {
        ...phaseEnvelope,
        fluid: {
          ...phaseEnvelope.fluid,
          state: {
            ...phaseEnvelope.fluid.state,
            name: phaseEnvelopeName,
          },
        },
        operations: [...baseOperations, ...derivedShutInOperations],
      };
    });
  }
}
